"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return TypeValidators;
    }
});
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
var TypeValidators = /*#__PURE__*/ function() {
    "use strict";
    function TypeValidators() {
        _classCallCheck(this, TypeValidators);
    }
    TypeValidators.validate = function validate(paramInfo, value) {
        if (TypeValidators.isArray(paramInfo.unit)) return TypeValidators.isArray(value);
        return TypeValidators.unitToValidatorMapping[paramInfo.unit](value);
    };
    TypeValidators.isString = function isString(value) {
        return typeof value === "string";
    };
    TypeValidators.isNumber = function isNumber(value) {
        return typeof value === "number";
    };
    TypeValidators.isArray = function isArray(value) {
        return _instanceof(value, Array);
    };
    return TypeValidators;
}();
TypeValidators.unitToValidatorMapping = {
    string: TypeValidators.isString,
    number: TypeValidators.isNumber,
    integer: TypeValidators.isNumber,
    ioExpander: TypeValidators.isNumber
};
TypeValidators.unitToExpectedTypeMapping = {
    string: "string",
    number: "numeric",
    integer: "numeric",
    ioExpander: "numeric"
};
